/* @flow */
import React, { Component } from 'react';
import { Grid, Tooltip, Typography, IconButton } from '@mui/material';
import { debounce } from 'throttle-debounce';
import customStyles from './EventList.module.scss';
import List from '../../SharedComponents/List/List';
import AppLoader from '../../AppLoader';
import { isEmpty, convertDateTime, getUserSettingTimeZone, getTimeFormatAsperUserSettting, getFormattedTimezone, getDateFormatFromUserSettings } from '../../../helper-classes/utility-functions';
import EventCard from './EventCard';
import { EVENT_TYPE_MAPPING, WHITE_COLOR, GRAY_COLOR, HARD_CORNERING_EVENT_TYPES, VIRTUAL_EVENTS } from './constants';
import GetSvgIcon from '../../../util/svgImage_util';
import { getDashcamColorFromStatus, getCsvData } from '../../../util/dashcam_util';
import { BACK_TO_EVENT_DEFAULT_PAGE, DASHCAM_EVENT_DOWNLOAD_API_CALL_THESHOLD, DASHCAM_MAX_EVENT_PER_PAGE_LIMIT } from '../../../containers/DashCam/constants.dashcam';
import { getAllSupportedEvents, getAllPagesData } from '../../../containers/DashCam/helper-classes/dashcamServices';


export type Props = {
    handleBackButtonClick: Function,
    dashcam: Object,
    events: any,
    setEventVideoPlayerEvent: Function,
    isEventListError: boolean,
    isAllDashcam: boolean,
    selectedFilter: Object,
    getFilterEvent: Function,
    trackAnalytics: Function,
    getNextPageData: Function,
    eventResponse: Object,
    currentPage: number,
    filterEventObj: any,
    uploadLoader: Function,
    dashcamNameData: Object,
};

export type State = {
    eventResponse: Array<Object>,
    currentPage: number,
    totalNumberOfPage: number,
    isLoading: boolean,
    isError: boolean,
    isAllDashcam: boolean,
    selectedFilter: Object,
    count: number,
    currentPage: number,
};

class EventList extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            eventResponse: this.props.events,
            isLoading: this.props.isLoader,
            isError: this.props.isEventListError,
            currentPage: this.props.currentPage,
            totalNumberOfPage: this.props.eventResponse.totalNumberOfPages,
            count: this.props.eventResponse.count,
            isAllDashcam: this.props.isAllDashcam,
            selectedFilter: !isEmpty(this.props.selectedFilter) ? this.props.selectedFilter : {},
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (this.props.events !== nextProps.events) {
            this.setState({ eventResponse: nextProps.events });
        }

        if (this.state.count !== nextProps.eventResponse.count ||
            this.state.totalNumberOfPage !== nextProps.eventResponse.totalNumberOfPages) {
            this.setState({
                totalNumberOfPage: nextProps.eventResponse.totalNumberOfPages,
                count: nextProps.eventResponse.count,
            });
        }

        if (this.props.isAllDashcam !== nextProps.isAllDashcam) {
            this.setState({ isAllDashcam: nextProps.isAllDashcam });
        }

        if (nextProps.selectedFilter &&
            this.props.selectedFilter &&
            this.props.selectedFilter.eventKey !== nextProps.selectedFilter.eventKey) {
            this.setState({ selectedFilter: nextProps.selectedFilter, currentPage: 0 });
        }

        if (this.state.isLoading !== nextProps.isLoader) {
            this.setState({ isLoading: nextProps.isLoader });
        }

        if (this.state.currentPage !== nextProps.currentPage) {
            this.setState({ currentPage: nextProps.currentPage });
        }
    }

    getNextPageDataWithDebounce = debounce(500, (page: number) => this.loadNextPage(page));

    loadNextPage = (page: number) => {
        this.props.getNextPageData(page)
    };

    getEventCardContent = (event: Object) => {
        const newEvent = event;
        newEvent.dashcamName = this.getDashcamName(event);
        if (!isEmpty(event)) {
            return (
                <EventCard
                    event={newEvent}
                    key={event.id}
                    setEventVideoPlayerEvent={this.props.setEventVideoPlayerEvent}
                    isAllDashcam={this.state.isAllDashcam}
                    trackAnalytics={this.props.trackAnalytics}
                />
            );
        }
        return '';
    };

    handleBackButtonClick = (isFilterSelected: boolean) => {
        if (isFilterSelected) this.props.getFilterEvent({});
        else this.props.handleBackButtonClick();
        if (!isFilterSelected) this.props.trackAnalytics(BACK_TO_EVENT_DEFAULT_PAGE);
        this.props.setEventVideoPlayerEvent(null);
    };

    getDashcamName = (event) => {
        const { dashcamNameData, isAllDashcam } = this.props;
        let dashcamName = event.dashcamName || '';
        if (isAllDashcam && !dashcamName) {
            // TODO we need to remove this dashcamNameData Mapping.
            // Once we start getting name from api
            dashcamName = dashcamNameData[event.imei] || event.imei;
        }

        return dashcamName;
    }

    getDownloadData = async () => {
        const { filterEventObj, uploadLoader, eventResponse, isAllDashcam } = this.props;
        const { count, selectedFilter } = this.state;
        const { startDate, endDate } = filterEventObj;
        let eventResponseData = eventResponse.events;
        const isVirtualEvent = selectedFilter &&
        selectedFilter.eventKey &&
        (VIRTUAL_EVENTS.includes(selectedFilter.eventKey));

        if (isAllDashcam) {
            const reqData = {
                totalCount: count,
                limit: DASHCAM_MAX_EVENT_PER_PAGE_LIMIT,
                eventType: getAllSupportedEvents(),
                maximumCalls: DASHCAM_EVENT_DOWNLOAD_API_CALL_THESHOLD,
                startDate,
                endDate,
                initValue: 0,
            };

            if (isVirtualEvent) {
                eventResponseData = this.props.eventResponse.virtualEvents
                    .filter(e => e.metadata === selectedFilter.eventKey);
            } else {
                if (selectedFilter && selectedFilter.eventKey) {
                    reqData.eventType = selectedFilter.eventKey === 'sharpTurnLeft' ? HARD_CORNERING_EVENT_TYPES : [selectedFilter.eventKey];
                }
                uploadLoader(true);
                const res = await getAllPagesData(reqData);
                uploadLoader(false);
                eventResponseData = [...res];
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (isVirtualEvent) {
                eventResponseData = this.props.eventResponse.events
                    .filter(e => e.metadata === selectedFilter.eventKey);
            } else if (selectedFilter && selectedFilter.eventKey) {
                const eventType = selectedFilter.eventKey === 'sharpTurnLeft' ? HARD_CORNERING_EVENT_TYPES.join('') : selectedFilter.eventKey;
                eventResponseData = eventResponseData
                    .filter(e => eventType.indexOf(e.eventType) > -1);
            }
        }

        return eventResponseData.map(d => ({
            date: convertDateTime(d.time, getDateFormatFromUserSettings()),
            dashcamName: this.getDashcamName(d),
            time: convertDateTime(d.time, (getTimeFormatAsperUserSettting() === '12h') ? 'h:mm A' : 'H:mm'),
            eventType: d.eventType === 'virtualEvent' ? d.metadata : EVENT_TYPE_MAPPING[d.eventType].name,
        }));
    }

    downloadEvent = async (fileName: string) => {
        const data = await this.getDownloadData();
        if (isEmpty(data)) return;
        let csvFileName = fileName;

        const header = ['Date', 'CamCoach Name', `Time in [${getFormattedTimezone(getUserSettingTimeZone())}]`, 'Event Type'];
        if (csvFileName === 'All Events') csvFileName = 'All';
        csvFileName = (csvFileName || '').replace(/\s+/g, '_').toLowerCase();
        getCsvData(data, header, `${csvFileName}_events`);
    }

    render() {
        const { dashcam } = this.props;
        const {
            isAllDashcam, eventResponse, selectedFilter, count,
        } = this.state;
        const dashcamStatusColor = getDashcamColorFromStatus(dashcam);
        let dashcamName = isAllDashcam ? 'All Events' : dashcam.name;
        const isFilterSelected = isAllDashcam && selectedFilter.eventKey;

        if (isFilterSelected) {
            dashcamName = EVENT_TYPE_MAPPING[selectedFilter.eventKey].name;
        }

        return (
            <React.Fragment>
                <div className={customStyles.container}>
                    <Grid container justifyContent="flex-start" alignItems={isAllDashcam ? 'flex-start' : 'center'} className={customStyles.event_list_header_card}>
                        <Grid item xs={10}>
                            <Grid container justifyContent="flex-start" alignItems="center">
                                <Grid item xs={2}>
                                    <Tooltip title="Back" disableFocusListener>
                                        <button
                                            className={customStyles.back_button}
                                            onClick={() =>
                                                this.handleBackButtonClick(isFilterSelected)}
                                        >
                                            <i className={customStyles.back_icon} />
                                        </button>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={7}>
                                    <Tooltip
                                        title={dashcamName}
                                        disableFocusListener
                                        placement="left"
                                    >
                                        <Typography variant="h5" className={`${customStyles.event_list_header_title} ${isAllDashcam ? customStyles.event_filter_selected : ''}`}>
                                            {dashcamName}
                                        </Typography>
                                    </Tooltip>
                                    <Typography variant="h5" className={customStyles.event_list_subheader_title}>
                                        <span>
                                            {isAllDashcam ? `Showing ${eventResponse.length} of ${count}` : dashcam.imei}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    {!isAllDashcam &&
                                    <Tooltip
                                        title={dashcam.status}
                                        disableFocusListener
                                        className={customStyles.dashcam_status_container}
                                    >
                                        <span>
                                            <GetSvgIcon
                                                type={dashcam.status === 'offline' ? 'offlineDashcam' : 'dashcamIcon'}
                                                viewBox={dashcam.status === 'offline' ? '0 0 27 22' : '0 0 22 14'}
                                                fillcolor={dashcamStatusColor}
                                                className={customStyles.dashcam_status_icon}
                                            />
                                        </span>
                                    </Tooltip>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2} className={customStyles.event_download}>
                            <div style={isEmpty(eventResponse) ? { cursor: 'not-allowed' } : {}}>
                                <IconButton
                                    onClick={() => this.downloadEvent(dashcamName)}
                                    disabled={isEmpty(eventResponse)}
                                    disableTouchRipple={isEmpty(eventResponse)}
                                    sx={{ '&.MuiIconButton-root': { padding: '12px' } }}
                                >
                                    <GetSvgIcon
                                        type="download"
                                        fillcolor={
                                            isEmpty(eventResponse) ?
                                                GRAY_COLOR : WHITE_COLOR}
                                        viewBox="-3 -2 24 24"
                                    />
                                </IconButton>
                            </div>
                        </Grid>
                    </Grid>
                    {/* event list */}
                    <Grid container>
                        <Grid item xs={12}>
                            {!this.state.isLoading && !this.state.isError &&
                            <List
                                data={this.state.eventResponse || []}
                                height={81}
                                currentPage={this.state.currentPage}
                                totalNumberofPage={this.state.totalNumberOfPage}
                                pagination={{
                                    isPagination: true,
                                    pageChanged: this.getNextPageDataWithDebounce,
                                }}
                                getListItem={this.getEventCardContent}
                                id="eventList"
                                loaderStyle={{
                                    'padding-top': '2px',
                                    'padding-bottom': '0px',
                                    display: 'block',
                                }}
                            />
                            }
                            {this.state.isLoading &&
                            <AppLoader
                                loaderStyle={{
                                    'padding-top': '10px',
                                    'padding-bottom': '10px',
                                    'text-align': 'center',
                                    display: 'block',
                                }}
                            />
                            }
                            { this.state.isError &&
                            <Typography variant="body1" className={customStyles.error_message}>
                                We are sorry a system error has occurred
                                while processing your request,
                                please try you request again.
                            </Typography>
                            }
                        </Grid>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}

export default EventList;
